import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { isEmpty } from 'lodash';
import { Box, Flex } from 'atoms';
import { setRecentUrl, toggleSidebar } from 'store/appSlice';
import { useAuth } from 'hooks';
import { SideBar, MainWindow, Header } from 'components';
import { handleLogout } from 'api/authentication';

export const BodyBox = Styled(Box)`
	width: 100%;
	padding-left: 240px;
`;

export const FlexBox = Styled(Flex)`
	overflow: hidden;
`;

function PrivateRoute({ children, breadCrumbsList = {}, settoggleTheme }) {
	const dispatch = useDispatch();
	const location = useLocation();
	const auth = useAuth();
	const { pathname = null } = location;

	useEffect(
		() => () => {
			/**
			 * to set last visited page url in redux store
			 */
			if (pathname) {
				dispatch(toggleSidebar(false));
				dispatch(setRecentUrl(pathname));
			}
		},
		[pathname, dispatch]
	);

	if (!auth || !auth?.access_token) {
		handleLogout();
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return (
		<FlexBox>
			<SideBar />
			<BodyBox>
				{!isEmpty(breadCrumbsList) && (
					<Header settoggleTheme={settoggleTheme} urls={breadCrumbsList} />
				)}
				<MainWindow>{children}</MainWindow>
			</BodyBox>
		</FlexBox>
	);
}

PrivateRoute.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	breadCrumbsList: PropTypes.object,
	settoggleTheme: PropTypes.func,
};

export default PrivateRoute;
